import React from 'react';
import { SvgIconContainer } from '../svg-icon-container/svg-icon-container';

export const UpliftLogo: React.FC = () => (
  <SvgIconContainer>
    <svg
      width="62"
      height="30"
      viewBox="0 0 62 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.074 13.5825C13.074 14.7779 13.0421 16.2377 12.3736 17.4013C11.705 18.5332 10.2087 19.6968 8.23489 19.6968C6.26107 19.6968 4.76478 18.5332 4.09622 17.4013C3.42767 16.2377 3.39583 14.7779 3.39583 13.5825V0.222168H0V14.4817C0 16.2483 0.371419 18.3745 2.06934 20.2363C3.23665 21.4951 5.19987 22.8279 8.23489 22.8279C11.2699 22.8279 13.2331 21.4951 14.4005 20.2363C16.0984 18.3745 16.4698 16.2483 16.4698 14.4817V0.222168H13.074V13.5825Z"
        fill="white"
      />
      <path
        d="M25.3096 8.02892C23.9088 8.02892 22.3382 8.49436 21.1391 9.92243V7.93372H17.8706V30H21.1391V20.7652C22.6035 22.5635 24.5773 22.8279 25.3414 22.8279C28.6736 22.8279 32.1437 20.0353 32.1437 15.3174C32.1437 10.8533 29.0025 8.02892 25.3096 8.02892ZM24.9063 19.8977C22.837 19.8977 20.9374 18.4062 20.9374 15.476C20.9374 12.4189 22.837 10.9591 24.9063 10.9591C27.2728 10.9591 28.8115 12.9584 28.8115 15.4443C28.8115 17.8667 27.2728 19.8977 24.9063 19.8977Z"
        fill="white"
      />
      <path
        d="M36.675 0.222168H33.2792V22.3837H42.5753V19.1996H36.675V0.222168Z"
        fill="white"
      />
      <path
        d="M36.675 0.222168H33.2792V22.3837H42.5753V19.1996H36.675V0.222168Z"
        fill="white"
      />
      <path
        d="M47.0641 1.3646C46.2682 2.23202 45.6952 3.59661 45.6952 5.75458V7.9337H44.2944V10.9274H45.6952V22.3942H48.9636V10.9168H52.4974V7.9337H48.9636V5.32087C48.9636 4.32651 49.3351 3.82933 49.4942 3.66008C49.9293 3.19464 50.5236 3.13117 50.9269 3.13117C51.3938 3.13117 51.8289 3.22637 52.4974 3.62835V0.401974C51.797 0.0952044 51.0966 0 50.3963 0C48.6983 0 47.669 0.729901 47.0641 1.3646Z"
        fill="white"
      />
      <path
        d="M58.6206 7.93374V3.2793H55.3521V7.93374H53.9937V10.9168H55.3521V22.3837H58.6206V10.9168H61.125V7.93374H58.6206Z"
        fill="white"
      />
      <path
        d="M41.0896 0.52892C39.8162 0.444294 38.755 1.50212 38.8399 2.77152C38.9142 3.83992 39.71 4.63329 40.7819 4.70734C42.0553 4.79197 43.1165 3.73414 43.0316 2.46474C42.9679 1.39634 42.1614 0.592389 41.0896 0.52892Z"
        fill="white"
      />
      <path
        d="M42.5752 7.93372H39.3067V17.3378H42.5752V7.93372Z"
        fill="white"
      />
    </svg>
  </SvgIconContainer>
);
